
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { BeneficiosDisponiblesResponse } from "@/models/Dashboard/BeneficiosDisponiblesResponse";
import ValidationService from "@/services/ValidationService";
import User from "@/models/User";
import AfiliadoService from "@/services/AfiliadoService";
import Swal from "sweetalert2";
import ValidacionCertificacionTss from "@/models/ValidacionCertificacionTss";
import { Getter } from "vuex-class";
import GlobalConfig from "@/GlobalConfig";
import ServiceResponseEntity from "@/services/response-models/ServiceResponseEntity";
import RequisitoBeneficio, {
  Requisito,
  ParametrosValidacionRequisitosBeneficio,
} from "@/models/RequisitoBeneficio";

import TipoRequisitoEnum from "@/enums/TipoRequisitoEnum";
import ServiceResponseSolicitudes from "@/services/response-models/ServiceResponseSolicitudes";
import ParametrosObtencionPresolicitud from "@/models/ParametrosObtencionPresolicitud";
import Presolicitud from "@/models/Presolicitud";
import { AxiosResponse } from "axios";
import { BIcon, BIconStopwatch, BIconArrowRepeat } from "bootstrap-vue";
@Component({ components: { BIcon, BIconStopwatch, BIconArrowRepeat } })
export default class Beneficios extends Vue {
  @Getter("isLoggedIn") isLoggedIn: boolean;
  @Prop({ default: "btn btn-info" }) className: string;
  @Prop({ default: true }) loading: boolean;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: null }) beneficiosDisponibles: BeneficiosDisponiblesResponse;
  @Prop({ default: false }) validarBeneficios: boolean;
  @Getter("user") user: User;
  public descriptionBeneficio: string = "";
  public montoBeneficio: string = "";
  public name: string = "";

  public validationService = new ValidationService();
  public afiliadoService = new AfiliadoService();
  async created() {}

  public async validatBeneficios() {
    const statusesPromise = Promise.allSettled([
      this.validarVejezAnticipada(),
      this.validarIngresoTardio(),
      this.validarCesantia(),
    ]);

    const [vejezResult, ingresoResult, cesantiaResult] = await statusesPromise;
    var aplicaVejez =
      vejezResult.status === "fulfilled" ? vejezResult.value : false;
    var aplicaIngresoTardio =
      ingresoResult.status === "fulfilled" ? ingresoResult.value : false;
    var aplicaCesantia =
      cesantiaResult.status === "fulfilled" ? cesantiaResult.value : false;
    //  console.log("Aplica  Vejez"+aplicaVejez);
    this.enableBeneficio(5, aplicaVejez);
    this.enableBeneficio(1, aplicaIngresoTardio);
    this.enableBeneficio(6, aplicaCesantia);
    this.loading = false;
    Swal.close();
  }
  mounted() {
    if (this.isLoggedIn) {
      const str = this.$store.state.user.primerNombre.toLowerCase();
      const arr = str.split(" ");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
      }
      const str2 = arr.join(" ");
      this.name = str2;
    }
  }
  public redirectToRegistroFallecimiento() {
    this.$router.push("/consulta-afiliado-fallecido");
  }
  public goBeneficiosAfiliado() {
    window.location.href =
      GlobalConfig.PUBLIC_WEB_URL + "/afiliados/beneficios-del-afiliado/";
  }

  public redirectToIngresoTardio() {
    if (!this.user.esAfiliadoFallecido) {
      this.$router.push("/devolucion-ingreso-tardio");
    } else {
      Swal.fire({
        text:
          "Llámanos a nuestros teléfonos 809-567-2371 o 1-809-200-2371 para obtener más información sobre procesar este beneficio.",
        icon: "info",
      });
    }
  }

  public redirectToCesantia() {
    if (!this.user.esAfiliadoFallecido) {
      this.$router.push("/cesantia");
    } else {
      Swal.fire({
        text:
          "Llámanos a nuestros teléfonos 809-567-2371 o 1-809-200-2371 para obtener más información sobre procesar este beneficio.",
        icon: "info",
      });
    }
  }

  public redirectToVejezAnticipada() {
    if (!this.user.esAfiliadoFallecido) {
      this.$router.push("/vejez-anticipada");
    } else {
      Swal.fire({
        text:
          "Llámanos a nuestros teléfonos 809-567-2371 o 1-809-200-2371 para obtener más información sobre procesar este beneficio.",
        icon: "info",
      });
    }
  }

  public onMouseEnter(obj: MouseEvent) {
    let eventTarget = obj.target as HTMLElement;
    let description = "";
    let monto = "";
    if (eventTarget.className.indexOf("menu-icon-option") > -1) {
      description = eventTarget.parentElement.dataset.description;
      monto = eventTarget.parentElement.dataset.monto;
    } else {
      description = eventTarget.dataset.description;
      monto = eventTarget.dataset.monto;
    }

    this.descriptionBeneficio = description;
    this.montoBeneficio = monto;
  }
  public onMouseLeave(obj) {
    this.descriptionBeneficio = "";
  }
  public LlenarDescripciones() {}
  public mostrarBeneficio(codigo: number) {
    return this.beneficiosDisponibles.data.some(
      (e) => e.codigoBeneficio == codigo && e.aplica == "S"
    );
    // return false;
  }
  public getBeneficioDescripcion(codigo: number) {
    let beneficio = this.beneficiosDisponibles.data.find(
      (e) => e.codigoBeneficio == codigo
    );
    if (beneficio != null) {
      return beneficio.mensaje;
    } else {
      return "";
    }
  }
  public getMontoBeneficio(codigo: number) {
    let beneficio = this.beneficiosDisponibles.data.find(
      (e) => e.codigoBeneficio == codigo
    );
    if (beneficio != null) {
      return "RD$ " + this.numberWithCommas(beneficio.monto.toFixed(2));
    } else {
      return "";
    }
  }
  public numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  public getBeneficioMonto(codigo: number) {
    let beneficio = this.beneficiosDisponibles.data.find(
      (e) => e.codigoBeneficio == codigo
    );
    if (beneficio != null) {
      return beneficio.monto;
    } else {
      return "";
    }
  }
  enableBeneficio(codigo: number, aplica: Boolean = false) {
    let beneficioIndex = this.beneficiosDisponibles.data.findIndex(
      (e) => e.codigoBeneficio == codigo
    );

    // console.log("index"+ beneficioIndex);
    // console.log("aplica"+ aplica);

    if (beneficioIndex != null) {
      if (aplica) {
        this.beneficiosDisponibles.data[beneficioIndex].aplica = "S";
      } else {
        this.beneficiosDisponibles.data[beneficioIndex].aplica = "N";
      }
    }
  }

  get aplicaBeneficios() {
    if (
      this.beneficiosDisponibles != null &&
      this.beneficiosDisponibles.data != null &&
      this.beneficiosDisponibles.data.some((e) => e.aplica == "S")
    ) {
      return true;
    } else {
      return false;
    }
  }
  public async validarTssIngresoTardio(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.validationService
        .validateIngresoTardio("")
        .then(
          async (
            response: AxiosResponse<
              ServiceResponseEntity<ValidacionCertificacionTss>
            >
          ) => {
            return resolve(response.data.entity.aplicaTramite);
          }
        )
        .catch((error) => {
          return resolve(false);
        });
    });
  }
  public async validarTssCesantia(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.validationService
        .validateCesantia("")
        .then(
          async (
            response: AxiosResponse<
              ServiceResponseEntity<ValidacionCertificacionTss>
            >
          ) => {
            return response.data.entity.aplicaTramite;
          }
        )
        .catch((error) => {
          return false;
        });
    });
  }

  public obtenerPresolicitudEnProceso(
    TipoBeneficioEnum: number
  ): Promise<Presolicitud> {
    return new Promise((resolve, reject) => {
      this.afiliadoService
        .getPresolicitud(
          new ParametrosObtencionPresolicitud(
            null,
            this.$store.state.user.cedula,
            null,
            null
          )
        )
        .then((response: AxiosResponse<ServiceResponseSolicitudes>) => {
          if (
            response.data.solicitudes &&
            response.data.solicitudes.length > 0
          ) {
            resolve(
              response.data.solicitudes.find(
                (x) =>
                  x.tipoBeneficio === TipoBeneficioEnum.toString() &&
                  !x.solCancelada &&
                  (!x.docFirmado || !x.solicitudPagada)
              )
            );
          } else {
            resolve(null);
          }
        })
        .catch((err) => {
          reject();
        });
    });
  }

  public validarRequisitosBeneficio(
    TipoBeneficioEnum: Number
  ): Promise<Boolean> {
    return new Promise((resolve, reject) => {
      const parametrosValidacionRequisitosBeneficio = new ParametrosValidacionRequisitosBeneficio(
        null,
        this.user.codCuenta,
        TipoRequisitoEnum.Validacion,
        Number(TipoBeneficioEnum)
      );
      this.validationService
        .validarRequisitosBeneficios(parametrosValidacionRequisitosBeneficio)
        .then(
          (
            response: AxiosResponse<ServiceResponseEntity<RequisitoBeneficio>>
          ) => {
            var result = response.data.entity.requisitos.every(
              (x) => x.cumpleRequisito
            );

            resolve(result);
          }
        )
        .catch(() => {
          reject();
        });
    });
  }

  public async validarIngresoTardio(): Promise<Boolean> {
    var tssValidation = await this.validarTssIngresoTardio();

    var solicitudesProceso = await this.obtenerPresolicitudEnProceso(1);
    var cumpleRequisitos = await this.validarRequisitosBeneficio(1);
    return tssValidation && solicitudesProceso == null && cumpleRequisitos;
  }
  public async validarCesantia(): Promise<Boolean> {
    var tssValidation = await this.validarTssIngresoTardio();
    var solicitudesProceso = await this.obtenerPresolicitudEnProceso(6);
    var cumpleRequisitos = await this.validarRequisitosBeneficio(6);
    return tssValidation && solicitudesProceso == null && cumpleRequisitos;
  }
  public async validarVejezAnticipada(): Promise<Boolean> {
    var solicitudesProceso = await this.obtenerPresolicitudEnProceso(5);
    var cumpleRequisitos = await this.validarRequisitosBeneficio(5);
    console.log()
    // console.log("Vejez solicitud en proceso:"+solicitudesProceso);
    // console.log("Vejez requisitos:"+cumpleRequisitos);

    return solicitudesProceso == null && cumpleRequisitos;
  }

  @Watch("validarBeneficios")
  public action(value: boolean) {
    this.validatBeneficios();
  }
  public showLoadingAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "info",
      //backdrop: false,
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
    });
  }
}
